<!-- SquareMissionMarker.vue -->
<template>
    <l-marker :lat-lng="latLng">
        <l-icon :icon="icon" :icon-size="[0, 0]" :icon-anchor="[14, 14]" :class="'mission-square'">
            <div style=" position: relative; width: 28px; height: 28px;">
                <svg width="28" height="28" viewBox="0 0 28 28">
                    <rect x="3" y="3" width="22" height="22" rx="4" fill="#fff" :stroke="color" stroke-width="2" />
                    <text x="14" y="19" text-anchor="middle" font-size="13" font-family="Arial" font-weight="bold"
                        :fill="color"> {{ point.num }}</text>
                </svg>
                <div style="
                  position: absolute;
                  left: 100%;
                  bottom: 0;
                  color: #fff;
                  font-size: 10px;
                  font-family: Arial, sans-serif;
                  font-weight: normal;
                  padding: 3px 10px 3px 10px;
                  border-radius: 4px;
                  margin-left: 4px;
                  white-space: nowrap;
                  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
                  line-height: 1.2;
                  display: inline-block;
                  opacity: 0.7;" :style="{ 'background': color }"> {{ clearNill(point.name) }}</div>
            </div>
        </l-icon>
        <l-tooltip v-if="tooltip" :style="`background: #fff; color: black; border-radius: 4px; font-weight: bold;`">
            <div v-html="tooltip"></div>
        </l-tooltip>
    </l-marker>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import L from 'leaflet'
import { LMarker, LTooltip, LIcon } from "@vue-leaflet/vue-leaflet"
import { useUtils } from '@/composables/useUtils'
const { clearNill } = useUtils()

const props = defineProps<{
    point: {
        num: string
        name?: string | null
        location: string | { coordinates: [number, number] }
        obs_escaped?: string
        color?: string
    }
    color?: string
}>()

const latLng = computed<[number, number]>(() => {
    try {
        const loc = typeof props.point.location === 'string'
            ? JSON.parse(props.point.location)
            : props.point.location
        return [loc.coordinates[1], loc.coordinates[0]] as [number, number]
    } catch {
        return [0, 0] as [number, number]
    }
})

const icon = L.divIcon({
    className: 'mission-square-icon'
    //iconSize: [28, 28],
    //iconAnchor: [14, 14]
})

const tooltip = computed(() => {
    let html = ''
    if (props.point.obs_escaped) {
        html += `<div style="white-space:pre-line;word-break:break-word;">${props.point.obs_escaped.replace(/\\n/g, '<br>')}</div>`
    }
    if (props.point.name) {
        html += `<div>${props.point.name}</div>`
    }
    if (props.point.location) {
        try {
            const loc = typeof props.point.location === 'string'
                ? JSON.parse(props.point.location)
                : props.point.location
            html += `<small>(${loc.coordinates[1].toFixed(6)}, ${loc.coordinates[0].toFixed(6)})</small>`
        } catch {
            // Ignore JSON parse/location errors
        }
    }
    return html
})
</script>
<style scoped>
.obs-tooltip {
    max-width: 220px;
    /* Ajusta el ancho máximo según tu preferencia */
    white-space: pre-line;
    /* Respeta saltos de línea y permite el wrap automático */
    word-break: break-word;
}

.mission-square-icon {
    margin-left: -14px !important;
    margin-top: -14px !important;
    width: 0px !important;
    height: 0px !important;
}

.mission-square {
    width: 28px;
    height: 28px;
    background: #fff;

    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
</style>